// extracted by mini-css-extract-plugin
export var documentation = "_kc-1";
export var menu = "_kc-0";